module.exports = __webpack_public_path__ + "img/top.b1c88676.webp";